<main class="open-catalog-container" itemscope itemtype="https://schema.org/ItemList">
  <meta itemprop="name" content="Catálogo de Espirituosos Estancos Distilling Co." />
  <meta itemprop="description"
    content="Colección abierta de destilados artesanales de alta gama madurados en la cordillera de los Andes." />

  <!-- CABECERA DE ESTILO NEOCLÁSICO -->
  <header class="neoclassic-catalog-hero">
    <div class="container">
      <div class="hero-crest" aria-hidden="true">
        <span class="crest-symbol">⚜</span>
      </div>
      <span class="catalog-subtitle">Colección Privada de Altura</span>
      <h1 class="catalog-title">Catálogo de Espirituosos</h1>
      <div class="classic-divider" aria-hidden="true">
        <span class="divider-line"></span>
        <span class="divider-diamond">◆</span>
        <span class="divider-line"></span>
      </div>
      <p class="catalog-lead-text">
        El alma de la cordillera andina capturada en cada botella. Destilados de nobleza artesanal, moldeados a 2500
        metros sobre el nivel del mar.
      </p>
    </div>
  </header>

  <!-- VERIFICACIÓN DEL ESTADO DE CARGA -->
  @if (isLoading()) {
  <div class="loader-container" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <div class="loader-text">Cargando Catálogo de Espirituosos...</div>
  </div>
  } @else {
  <!-- LISTA ABIERTA DE PRODUCTOS (SIN LÍNEAS DIVISORAS) -->
  <div class="open-catalog-list">
    @for (product of products(); track product.id; let i = $index) {
    <article class="catalog-item-section" [id]="product.id" itemprop="itemListElement" itemscope
      itemtype="https://schema.org/Product">
      <meta itemprop="position" [content]="i + 1" />
      <div class="container">
        <div class="catalog-item-grid" [class.layout-reverse]="product.reverseLayout">

          <!-- Muestra visual de la botella (Luz radial abierta) -->
          <div class="product-media-col">
            <div class="media-halo-wrapper">
              <div class="roman-numeral-tag" aria-hidden="true">
                {{ i === 0 ? 'N° I' : i === 1 ? 'N° II' : i === 2 ? 'N° III' : 'N° ' + (i + 1) }}
              </div>
              <img [src]="getOptimizedImageUrl(product.image_url, 600, 85)"
                [alt]="'Botella de ' + product.name + ' - Destilado Andino'"
                class="product-item-img"
                [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
                decoding="async"
                width="500"
                height="650"
                itemprop="image"
                (error)="onImageError($event, product.name)">
            </div>
          </div>

          <!-- Detalles y Notas de Cata -->
          <div class="product-content-col">
            <div class="item-meta-header">
              <span class="item-category-tag" itemprop="category">{{ product.type || 'Espíritu Andino' }}</span>
              <span class="item-edition-badge">Edición Limitada</span>
            </div>

            <h2 class="item-title" itemprop="name">{{ product.name }}</h2>

            <!-- CALIFICACIÓN 5 ESTRELLAS DINÁMICA -->
            <div class="item-rating-row">
              <a [routerLink]="product.detailUrl" fragment="opiniones" class="catalog-rating-link" title="Ver opiniones de catadores">
                <div class="catalog-stars" [attr.aria-label]="(product.rating || 5) + ' de 5 estrellas'">
                  @for (star of getStarsArray(5); track star) {
                  <span class="star" [class.filled]="star <= (product.rating || 5)">★</span>
                  }
                </div>
                <span class="rating-num">{{ (product.rating || 5.0) | number:'1.1-1' }}</span>
                <span class="rating-label">({{ product.reviewsCount || 0 }} {{ product.reviewsCount === 1 ? 'opinión' : 'opiniones' }})</span>
              </a>
            </div>

            <!-- Especificaciones clave neoclásicas -->
            <div class="item-specs-row" role="list">
              <div class="spec-pill" role="listitem">
                <span class="pill-label">Graduación</span>
                <span class="pill-val">{{ product.abv || '40% Vol.' }}</span>
              </div>
              <div class="spec-pill" role="listitem">
                <span class="pill-label">Añejamiento</span>
                <span class="pill-val">{{ product.age || '8 Años' }}</span>
              </div>
              <div class="spec-pill" role="listitem">
                <span class="pill-label">Origen</span>
                <span class="pill-val">Andes 2500 MSNM</span>
              </div>
            </div>

            <p class="item-description" itemprop="description">
              {{ getShortDescription(product) }}
            </p>

            <!-- METADATOS SCHEMA.ORG DE PRODUCTO -->
            <div itemprop="brand" itemscope itemtype="https://schema.org/Brand" style="display:none;">
              <meta itemprop="name" content="Estancos Distilling Co." />
            </div>

            <div itemprop="offers" itemscope itemtype="https://schema.org/Offer" style="display:none;">
              <meta itemprop="price" [content]="product.price" />
              <meta itemprop="priceCurrency" content="USD" />
              <meta itemprop="availability" content="https://schema.org/InStock" />
              <meta itemprop="seller" content="Estancos Distilling Co." />

              <!-- POLÍTICA DE ENVÍOS (SHIPPING DETAILS - FICHA COMERCIANTE GOOGLE) -->
              <div itemprop="shippingDetails" itemscope itemtype="https://schema.org/OfferShippingDetails">
                <div itemprop="shippingRate" itemscope itemtype="https://schema.org/MonetaryAmount">
                  <meta itemprop="value" content="5.00" />
                  <meta itemprop="currency" content="USD" />
                </div>
                <div itemprop="shippingDestination" itemscope itemtype="https://schema.org/DefinedRegion">
                  <meta itemprop="addressCountry" content="EC" />
                </div>
                <div itemprop="deliveryTime" itemscope itemtype="https://schema.org/ShippingDeliveryTime">
                  <div itemprop="handlingTime" itemscope itemtype="https://schema.org/QuantitativeValue">
                    <meta itemprop="minValue" content="1" />
                    <meta itemprop="maxValue" content="5" />
                    <meta itemprop="unitCode" content="d" />
                  </div>
                  <div itemprop="transitTime" itemscope itemtype="https://schema.org/QuantitativeValue">
                    <meta itemprop="minValue" content="1" />
                    <meta itemprop="maxValue" content="4" />
                    <meta itemprop="unitCode" content="d" />
                  </div>
                </div>
              </div>

              <!-- POLÍTICA DE DEVOLUCIONES (MERCHANT RETURN POLICY - FICHA COMERCIANTE GOOGLE) -->
              <div itemprop="hasMerchantReturnPolicy" itemscope itemtype="https://schema.org/MerchantReturnPolicy">
                <meta itemprop="applicableCountry" content="EC" />
                <meta itemprop="returnPolicyCategory" content="https://schema.org/MerchantReturnFiniteReturnWindow" />
                <meta itemprop="merchantReturnDays" content="15" />
                <meta itemprop="returnMethod" content="https://schema.org/ReturnByMail" />
                <meta itemprop="returnFees" content="https://schema.org/FreeReturn" />
              </div>
            </div>

            <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating" style="display:none;">
              <meta itemprop="ratingValue" [content]="product.rating || 5.0" />
              <meta itemprop="reviewCount" [content]="product.reviewsCount || 1" />
              <meta itemprop="bestRating" content="5" />
              <meta itemprop="worstRating" content="1" />
            </div>

            <!-- 3 MEJORES OPINIONES DE CATADORES -->
            @if (product.topReviews && product.topReviews.length > 0) {
            <div class="top-reviews-section">
              <div class="top-reviews-header">
                <div class="header-left">
                  <span class="header-star-icon">★</span>
                  <h3 class="header-title">Opiniones Destacadas de Catadores</h3>
                </div>
                <a [routerLink]="product.detailUrl" fragment="opiniones" class="header-see-all">
                  <span>Ver todas ({{ product.reviewsCount }})</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>

              <div class="top-reviews-grid">
                @for (rev of product.topReviews; track rev.id) {
                <div class="mini-review-card" itemprop="review" itemscope itemtype="https://schema.org/Review">
                  <div class="mini-card-header">
                    <div class="mini-avatar" aria-hidden="true">{{ getInitials(rev.customer_name) }}</div>
                    <div class="mini-author-meta">
                      <div class="mini-name-row">
                        <span class="mini-name" itemprop="author" itemscope itemtype="https://schema.org/Person">
                          <span itemprop="name">{{ rev.customer_name }}</span>
                        </span>
                        @if (rev.is_verified) {
                        <span class="mini-verified-badge" title="Catador / Comprador Verificado">✓</span>
                        }
                      </div>
                      <span class="mini-city">{{ rev.customer_city || 'Ecuador' }}</span>
                    </div>
                    <div class="mini-stars" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating" aria-label="Calificación de la reseña">
                      <meta itemprop="ratingValue" [content]="rev.rating" />
                      <meta itemprop="bestRating" content="5" />
                      <meta itemprop="worstRating" content="1" />
                      @for (star of getStarsArray(5); track star) {
                      <span class="mini-star" [class.filled]="star <= rev.rating">★</span>
                      }
                    </div>
                  </div>
                  @if (rev.title) {
                  <h4 class="mini-title" itemprop="name">"{{ rev.title }}"</h4>
                  }
                  <p class="mini-comment" itemprop="reviewBody">{{ rev.comment }}</p>
                </div>
                }
              </div>
            </div>
            }

            <!-- Botones de Acción Neoclásicos -->
            <div class="item-actions-group">
              <button class="btn-neoclassic-cart" (click)="add(product)" aria-label="Añadir al carrito">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2.2" class="cart-icon" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
                <span>Añadir al Carrito</span>
                <span class="btn-price-tag">${{ product.price | number:'1.2-2' }}</span>
              </button>

              @if (product.name.toLowerCase().includes('legarda')) {
              <a routerLink="/espiritus/ron-legarda" class="btn-neoclassic-page"
                title="Explorar notas de cata completas de Ron Legarda">
                <span>Ver Notas de Cata y Reseñas</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2.2" class="arrow-icon" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              } @else if (product.name.toLowerCase().includes('chillos') ||
              product.name.toLowerCase().includes('valley')) {
              <a routerLink="/espiritus/whiskey-chillos-valley" class="btn-neoclassic-page"
                title="Explorar notas de cata completas de Whiskey Chillos Valley">
                <span>Ver Notas de Cata y Reseñas</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2.2" class="arrow-icon" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              } @else if (product.name.toLowerCase().includes('audiencia')) {
              <a routerLink="/espiritus/whisky-real-audiencia" class="btn-neoclassic-page"
                title="Explorar notas de cata completas de Whisky Real Audiencia">
                <span>Ver Notas de Cata y Reseñas</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" stroke-width="2.2" class="arrow-icon" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              }
            </div>

          </div>

        </div>
      </div>
    </article>
    }
  </div>
  }
</main>

<!-- TOAST NOTIFICATION DE AGREGADO AL CARRITO -->
@if (toastMessage()) {
<div class="toast-notification" role="status" aria-live="polite">
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor"
    stroke-width="2" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
  </svg>
  <span>{{ toastMessage() }}</span>
</div>
}